<script lang="ts">
	import FileUpload from "$form/Fields/Shared/FileUpload.svelte";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import { getContext } from "svelte";
	import { createEventDispatcher, onMount } from "svelte";
	import type { Writable } from "svelte/store";

	export let field: FieldDisplay & { type: "FileUpload" };
	export let value: FileUploadResponseField["value"];

	const formKey = getContext<string>("formKey");
	const styling = getContext<Styling>("styling");
	const plan = getContext<PlanShort>("plan");
	let uploadsInProgress =
		getContext<Writable<{ [key: string]: number }>>("uploadsInProgress");
	const maxSize = Math.min(
		field.settings.maxSize ? parseInt(field.settings.maxSize) : 1024 * 1024,
		plan.uploads_size * 1024
	);

	let inputRef: HTMLInputElement;
	const dispatch = createEventDispatcher();

	onMount(() => {
		inputRef.addEventListener("focus", () => {
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("blur", () => {
			dispatch("updateOther", {
				tainted: true
			});
			dispatch("updateOther", {
				active: false
			});
		});
	});
</script>

<div
	class="field-label-cover"
	class:has-placeholder="{styling.placeholders !== false}">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<FileUpload
		bind:element="{inputRef}"
		bind:value="{value}"
		on:progressChange="{(e) => {
			if (typeof $uploadsInProgress[field.id] === 'undefined') {
				$uploadsInProgress[field.id] = 0;
			}
			$uploadsInProgress[field.id] = e.detail?.value ?? 0;
		}}"
		min="{field.settings.min}"
		max="{field.settings.max}"
		maxSize="{maxSize}"
		allowedTypes="{field.settings.allowedTypes ?? []}"
		allowedExtensions="{field.settings.allowedExtensions ?? ''}"
		form="{formKey}"
		name="{field.id}"
		placeholder="{styling.placeholders ? field.labelComputed : ''}"
		label="{field.labelHTMLComputed}" />
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
